<template>
    <div>
        <allTitle ref="allTitle" />

        <el-dialog title="" :visible.sync="dialogVisible" width="430px" :before-close="handleClose" center
            class="zfCode">
            <div class="lock">

                <div class="right">
                    <div class="rightTop">
                        <div> <img :src="kfImg" style="width: 120px;height: 120px;" alt="">
                        </div>
                        <div style="margin-top: 30px;margin-left: 30px;">对公转账请添加客服专员{{ kfName }}进行操作</div>
                    </div>

                </div>
            </div>



        </el-dialog>
    </div>
</template>

<script>
import { addMember, getPersonVipStatusByOrderSn } from "@/api/user"
import QRCode from 'qrcodejs2';

export default {
    data() {
        return {
            dialogVisible: false,
            timer: null,
            ifShow: true,
            kfName: '',
            kfImg: ''
        }
    },
    methods: {
        titleShow(msg) {
            this.$refs.allTitle.msg = msg
            this.$refs.allTitle.routerPath = null;
            this.$refs.allTitle.dialogVisible = true;
        },
        handleClose() {
            this.dialogVisible = false
        },
        getCode(kfName, kfImg) {
            this.dialogVisible = true
            this.kfName = kfName
            this.kfImg = kfImg

        }
    },
    created() { },
    mounted() {
    }
}
</script>

<style lang=scss scoped>
::v-deep .zfCode .el-dialog {
    background-color: #3577E8;
    border-radius: 20px;
}

::v-deep .zfCode .el-dialog--center .el-dialog__body {
    padding: 40px 24px 10px
}

::v-deep .zfCode .el-dialog__header {
    padding: 0px !important;
}


.lock {
    height: 193px;
    width: 100%;
    background-color: #3577E8;
    display: flex;
    box-sizing: border-box;



    .right {
        width: 100%;
        height: 100%;

        .rightTop {
            width: 98%;
            height: 168px;
            background-color: rgb(74, 133, 234);
            color: white;
            font-size: 14px;
            border-radius: 10px;
            display: flex;
            padding: 30px 20px;
            box-sizing: border-box;
        }

        .rightBottom {
            // margin-top: 16px;
            width: 98%;
            height: 90.5%;
            background-color: #4A85EA;
            color: white;
            font-size: 14px;
            border-radius: 10px;
            padding: 52px 20px;
            box-sizing: border-box;
            display: flex;
        }
    }
}
</style>